import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import { Row, Col, Card, Table, Button, Badge, Modal } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import RoundedPagination from "../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from "../../util/generalUtills";
import Preloader from "../../Components/Preloader";
import { deleteCameraNvrData, getCameraNvrList, updateCameraNvrStatusData, getCameraNvrListById, updateCameraNvrData } from "../../redux/actions/CameraNvrActions";
import VideoModal from "../../Components/VideoModal";
import Status from "../../enums/Status";



const Dashboard = () => {
  const { t } = useTranslation();
  const tableRef = useRef();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    AuthReducer: { auth, errors },
    cameraNvrReducer: {
       cameraNvrLists,
    cameraNvrStatus,
    cameraNVrPermissions,
    changedCameraNvrStatus,
    cameraNvrCount,
    loadingCameraNvr,
    errorsCameraNvr,
    },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort] = useState('desc');
  // const [showVideoModal, setShowVideoModal] = useState(false);
  // const [selectedCamera, setSelectedCamera] = useState(null);
  // const [showImageModal, setShowImageModal] = useState(false);
  // const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  // const [imageLoading, setImageLoading] = useState(true);
  // const [imageError, setImageError] = useState(false);

  // useEffect(() => {
  //   dispatch(getCityList(auth?.accessToken, paginate, page, search, sort));
  // }, [auth, paginate, page, search, sort]);

  const fetchCameraNvrList = useCallback(() => {
    if (auth?.accessToken) {
      dispatch(getCameraNvrList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchCameraNvrList, 500, [auth, paginate, page, search, sort]);
  useEffect(() => {
    if (errors) {
      if (errors?.status === 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate])

  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? cameraNvrCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleDeleteRequest = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteCameraNvrData(auth?.accessToken, id))
        }
      });
  };

  const handleStatusChangeRequest = (item, newStatus) => {
    swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${newStatus}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        
        dispatch(updateCameraNvrData(auth?.accessToken, {
          type: "status",
           "nvrName": item?.nvrName,
          "nvrUrl": item?.nvrUrl,
          "nvrUsername": item?.nvrUsername,
          "nvrPassword": item?.nvrPassword,
          "location": item?.location,
          "nvrPort": item?.nvrPort,
          "status": newStatus,
        },item?.id,));
      }
    });
  };

  // const handlePlayVideo = (camera) => {
  //   setSelectedCamera(camera);
  //   setShowVideoModal(true);
  //   // Optionally dispatch action to get detailed camera data
  //   if (auth?.accessToken) {
  //     dispatch(playCameraData(auth?.accessToken, camera.id));
  //   }
  // };

  // const handleCloseVideoModal = () => {
  //   setShowVideoModal(false);
  //   setSelectedCamera(null);
  // };

  // const handleImageClick = (externalId) => {
  //   const imageUrl = `https://phedrserver.consoletrack.com/upload/cameras/${externalId}/camera_${externalId}.jpg`;
  //   setSelectedImageUrl(imageUrl);
  //   setImageLoading(true);
  //   setImageError(false);
  //   setShowImageModal(true);
  // };

  // const handleCloseImageModal = () => {
  //   setShowImageModal(false);
  //   setSelectedImageUrl(null);
  //   setImageLoading(false);
  //   setImageError(false);
  // };

  // const handleImageLoad = () => {
  //   setImageLoading(false);
  //   setImageError(false);
  // };

  // const handleImageError = () => {
  //   setImageLoading(false);
  //   setImageError(true);
  // };

  // const getImageUrl = (externalId) => {
  //   return `https://phedrserver.consoletrack.com/upload/cameras/${externalId}/camera_${externalId}.jpg`;
  // };


  useEffect(() => {
    if (changedCameraNvrStatus?.message) {
      swal.fire({
        show: true,
        // title: "Deleted!",
        text: changedCameraNvrStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CAMERANVR_STATUS' });
      dispatch(getCameraNvrList(auth?.accessToken, paginate, page, search, sort));
    }
    else if (changedCameraNvrStatus?.message) {
      swal.fire({
        show: true,
        title: "Great !",
        text: changedCameraNvrStatus.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CAMERANVR_STATUS' });
      dispatch(getCameraNvrList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [changedCameraNvrStatus, auth?.accessToken, dispatch, paginate, page, search, sort])


  useEffect(() => {
    if (errorsCameraNvr && Object.keys(errorsCameraNvr).length > 0) {
      if (errorsCameraNvr?.status === 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
      }
    }
  }, [errorsCameraNvr, dispatch, errors?.data?.message, navigate]);


  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("came-nvr"), path: "/camera-nvr", active: true },
        ]}
        title={t("camera-nvr")}
      />

      <Row>
        <Col>
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white border-0 pb-0">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center">
                    <i className="mdi mdi-camera text-primary" style={{ fontSize: '1.5rem' }}></i>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h4 className="mb-0">Camera-Nvr</h4>
                  <p className="text-muted mb-0">Monitor and manage all surveillance camera's Nvr</p>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="pt-3">
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    {(cameraNVrPermissions?.filter) && (
                      <>
                        <div className="d-flex align-items-center position-relative">
                          <i className="mdi mdi-magnify position-absolute" style={{ left: '15px', zIndex: 2, color: '#6c757d' }}></i>
                          <input
                            type="search"
                            placeholder="Search camera's nvr ..."
                            className="form-control ps-5 border-0 bg-light"
                            autoComplete="off"
                            value={search}
                            onChange={handleSearchChange}
                            style={{ borderRadius: '25px' }}
                          />
                        </div>
                      </>
                    )}
                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                        {(cameraNVrPermissions?.add) && (
                          <>
                            <Link to="/Add-camera-nvr">
                              <Button
                                variant="success"
                                className="me-2"
                                style={{ borderRadius: '25px', fontWeight: '500' }}
                              >
                                <i className="mdi mdi-plus me-1"></i>Add Camera NVR
                              </Button>
                            </Link>
                          </>
                        )}
                        {(cameraNVrPermissions?.print) && (
                          <>
                            <Button
                              variant="outline-secondary"
                              className="me-2"
                              style={{ borderRadius: '25px', fontWeight: '500' }}
                            >
                              <i className="mdi mdi-printer me-1"></i>Print
                            </Button>
                          </>
                        )}
                        {(cameraNVrPermissions?.excel) && (
                          <>
                            <Button
                              variant="outline-info"
                              style={{ borderRadius: '25px', fontWeight: '500' }}
                            >
                              <i className="mdi mdi-file-excel me-1"></i>Export
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="table-responsive" style={{ overflowY: 'auto', maxHeight: '500px', borderRadius: '10px', border: "1px solid #e9ecef" }}>
                <Table ref={tableRef} className="mb-0 table-hover"
                  responsive
                  id="table-to-print"
                  style={{ width: "100%", tableLayout: "auto" }}>
                  <thead style={{ position: "sticky", top: 0, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", zIndex: 1 }}>
                    <tr>
                      <th className="text-white fw-semibold border-0">#</th>
                      <th className="text-white fw-semibold border-0">NVR NAME</th>
                      <th className="text-white fw-semibold border-0">NVR PORT</th>
                      <th className="text-white fw-semibold border-0">NVR URL</th>
                  <th className="text-white fw-semibold border-0">LOCATION</th>
                      <th className="text-white fw-semibold border-0">Status</th>
                      <th className="text-white fw-semibold border-0">Registered At</th>
                      <th className="text-white fw-semibold border-0">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cameraNvrLists?.length === 0 ? (
                      <tr>
                        <td colSpan="11">No data found</td>
                      </tr>
                    ) : (<>
                      {cameraNvrLists?.map?.((item, index) => {
                        return (
                          <tr key={item.id}>
                            <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                            {/* <td>
                              {item?.externalId ? (
                                <img
                                  src={getImageUrl(item.externalId)}
                                  alt={item?.cameraName || 'Camera'}
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                    objectFit: 'cover',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    border: '2px solid #e9ecef'
                                  }}
                                  onClick={() => handleImageClick(item.externalId)}
                                  onError={(e) => {
                                    e.target.src = 'https://via.placeholder.com/60x60?text=No+Image';
                                  }}
                                />
                              ) : (
                                <div style={{
                                  width: '60px',
                                  height: '60px',
                                  backgroundColor: '#f0f0f0',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#999'
                                }}>
                                  <i className="mdi mdi-image-off" style={{ fontSize: '24px' }}></i>
                                </div>
                              )}
                            </td> */}
                            <td>{item?.nvrName}</td>
                            <td>{item?.nvrPort}</td>
                            <td>{item?.nvrUrl}</td>
                            <td>{item?.location}</td>
                            <td>{item?.status === Status.ACTIVE ? <Badge className={"bg-success"}>{item?.status}</Badge> : <><Badge className={"bg-danger"}>{item?.status}</Badge></>}</td>
                            <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                           
                            <td>
                              {(cameraNVrPermissions?.edit) && (
                                <>
                                  {item?.status === Status.ACTIVE && (
                                    <>
                                      <Link to="#" className="action-icon text-success" onClick={() => handleStatusChangeRequest(item, Status.INACTIVE)}>
                                        {" "}
                                        <i className="mdi mdi-eye"></i>
                                      </Link>
                                    </>
                                  )}
                                  {item?.status === Status.INACTIVE && (
                                    <>
                                      <Link to="#" className="action-icon text-warning" onClick={() => handleStatusChangeRequest(item, Status.ACTIVE)}>
                                        {" "}
                                        <i className="mdi mdi-eye-off"></i>
                                      </Link>
                                    </>
                                  )}

                                  <Link to={`/Update-camera-nvr/${item?.id}`} className="action-icon text-info me-2">
                                    <i className="mdi mdi-square-edit-outline"></i>
                                  </Link>
                                  {/* <Button
                                    variant="link"
                                    className="action-icon text-primary p-0 me-2"
                                    onClick={() => handlePlayVideo(item)}
                                    title="Play Video"
                                  >
                                    <i className="mdi mdi-play-circle" style={{ fontSize: '1.2rem' }}></i>
                                  </Button> */}
                                </>
                              )}

                              {(cameraNVrPermissions?.delete) && (
                                <>
                                  <Link to="#" className="action-icon text-danger" onClick={() => handleDeleteRequest(item?.id)} >
                                    {" "}
                                    <i className="mdi mdi-delete"></i>
                                  </Link>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}</>
                    )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(cameraNvrCount / paginate)}</strong> </span>
                <RoundedPagination
                  currentPage={page}
                  totalPages={Math.ceil(cameraNvrCount / paginate)}
                  onPageChange={(pageNumber) => setPage(pageNumber)}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>



      {loadingCameraNvr && (<Preloader />)}
    </>
  );
};

export default Dashboard;
